import { Button, Form, Input, Spin, Typography } from 'antd'
import React, { useState } from 'react'
import { LoadingOutlined, SaveOutlined } from '@ant-design/icons'
import configssAdmin from '../../../../apis/admin/config.service'
import notificationHandler from '../../../atoms/Notification'

type Props = {}

const CreateQrcode = (props: Props) => {
    const [form] = Form.useForm();
    const { Title } = Typography;
    const [loading, setLoading] = useState(false);
    const [isQrcode, setIsQrcode] = useState(false);
    const [qrcode, setQrcode] = useState('');


    const antIcon = <LoadingOutlined style={{ fontSize: 70, position: 'fixed' }} spin />;

    const onFinish = (values: any) => {
        const param = {
            url: values.url,
            width: 500,
            height: 500
        }
        setLoading(true);
        configssAdmin.getQRcode(param).then((res: any) => {
            // console.log("res", res);
            
            notificationHandler('success', 'Lấy mã QR thành công!')
            setIsQrcode(true);
            setLoading(false);
            setQrcode(res?.data?.data?.payload);
        }).catch((err) => {
            notificationHandler('error', err.response.data.data.msg_content)
            setLoading(false);
        })

    };
    const getQrImage = () => {
        var a = document.createElement("a"); //Create <a>
        a.href = "data:image/png;base64," + qrcode; //Image Base64 Goes here
        a.download = "qrcode.png"; //File name Here
        a.click(); 

    };
    return (
        <div className='p-[20px]'>
            <Spin indicator={antIcon} spinning={loading} />
            <Title className='!text-[20px]'>Tạo mã QR CODE</Title>
            <Form
                form={form}
                name="basic"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600 }}
                initialValues={{ remember: true }}
                layout={'vertical'}
                onFinish={onFinish}
                autoComplete="off"
            >
                <Form.Item label="Nhập link sinh mã"
                    // @ts-ignore
                    onBlur={(e) => {
                        form.setFieldValue('url', e.target.value.trim())
                    }}
                    // normalize={(value) => value.trim()}
                    name="url"
                    rules={[{ required: true, message: 'Vui lòng nhập link sinh mã qr code!' }]}>
                    <Input placeholder='Nhập link sinh mã' />
                </Form.Item>
                <Button htmlType="submit" type='primary' className='mt-4 bg-[#1890ff] hover:bg-white hover:text-[#1890ff]' loading={loading}> <SaveOutlined />Tạo QR</Button>
            </Form>
            {
                isQrcode && <>
                <div className='qr_code_image' style={{marginTop: '30px'}}>
                    <img src={`data:image/png;base64,${qrcode}`} alt='qrcode' />
                </div>
                    <Button onClick={() => getQrImage()} type='primary' className='mt-4 bg-[#1890ff] hover:bg-white hover:text-[#1890ff]' loading={loading}> <SaveOutlined />Tải mã</Button>
                </> 
            }

        </div>
    )
}

export default CreateQrcode
